import { createTheme, type ThemeOptions } from "@mui/material/styles";

const pacBioBlue = "#0066CC";
const pacBioNavy = "#1A2332";

const baseOptions: ThemeOptions = {
  typography: {
    fontFamily: "'Inter', sans-serif",
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: false,
      },
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.borderRadius,
          boxShadow:
            theme.palette.mode === "light"
              ? "0 1px 3px rgba(26, 35, 50, 0.08), 0 1px 2px rgba(26, 35, 50, 0.06)"
              : "0 1px 3px rgba(0, 0, 0, 0.35), 0 1px 2px rgba(0, 0, 0, 0.28)",
        }),
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: ({ theme }) => ({
          boxShadow:
            theme.palette.mode === "light"
              ? "0 1px 3px rgba(26, 35, 50, 0.08), 0 1px 2px rgba(26, 35, 50, 0.06)"
              : undefined,
        }),
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "0 1px 0 rgba(0, 0, 0, 0.06)",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
};

export function getTheme(mode: "light" | "dark") {
  return createTheme({
    ...baseOptions,
    palette: {
      mode,
      primary: {
        main: pacBioBlue,
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: pacBioNavy,
        contrastText: "#FFFFFF",
      },
      ...(mode === "light"
        ? {
            background: {
              default: "#F5F7FA",
              paper: "#FFFFFF",
            },
            text: {
              primary: pacBioNavy,
              secondary: "rgba(26, 35, 50, 0.72)",
            },
            divider: "rgba(26, 35, 50, 0.12)",
          }
        : {
            background: {
              default: "#0D1117",
              paper: "#161B22",
            },
            text: {
              primary: "#F0F4F8",
              secondary: "rgba(240, 244, 248, 0.65)",
            },
            divider: "rgba(240, 244, 248, 0.12)",
          }),
    },
  });
}
